import React, {useContext} from "react";
import {UserContext} from "./UserContext";

const ListItemDiagnosticTestResultStudent = props => {
    const {testResult, callback} = props;
    const {user} = useContext(UserContext);

    return (
        <tr>
            <td className={'padding-y--m'}>
                <div className={'padding-b--s'}>
                    {callback &&
                        <div className={'ch-link'} onClick={callback} >
                            {testResult.testName}
                        </div>
                    }
                    {!callback &&
                        <span>
                            {testResult.testName}
                        </span>
                    }
                </div>
            </td>
            <td className={'padding-y--m'}>
                <div className={'ch-listItem-testResults margin-b--s'}>
                    {testResult.testQuestionResults.map((questionResult, index) => (
                        <div key={index} className={'ch-testResult-mark'}>
                            <div className={'ch-testResult-mark-inner ' + (questionResult.mark !== undefined ? (questionResult.result !== undefined && questionResult.result ? 'ch-testResult-mark-success' : 'ch-testResult-mark-fail') : '')}></div>
                        </div>
                    ))}
                </div>
            </td>
            {!testResult.total &&
                <td align="center" colSpan={2}>
                    <span style={{textTransform: 'capitalize'}}>{testResult.testAssignmentStatus.toLowerCase()}</span>
                </td>
            }
            {testResult.total &&
                <>
                    <td align="center">
                        {testResult.mark}/{testResult.maxMark}<br/>
                        {testResult.percentCorrect}%
                    </td>
                </>
            }
        </tr>
    )
}

export default ListItemDiagnosticTestResultStudent;